import EventBus from 'event_bus'

import { AllTag, CategoryTag, SearchTerms, TagSink } from 'indexing'

import Headline from './headline'
import JobList from './job_list'
import SaveSearch from './save_search'
import renderPill from './templates/pill'

export default ($context = document) => {
  $(() => {
    const eventNameSpace = 'filter-settings'

    $('.js-filter-summary__reset', $context).on('click', function (event) {
      event.preventDefault()
      EventBus.trigger(`${eventNameSpace}:reset`, null)
      $('html, body').animate({ scrollTop: 0 }, 'fast')
    })

    $('.js-search-profile__reset-tags', $context).on('click', function (event) {
      event.preventDefault()
      EventBus.trigger('search-profile-tag:reset', null)
    })

    const filterPill = (pill) => renderPill(pill, 'filter-summary__pill js-tag-sink__pill')

    $('.js-filter-summary__pills', $context).map(function () {
      new TagSink($(this), filterPill, '.js-tag-sink__pill', '.js-search-input__remove', eventNameSpace)
    })

    $('.js-filter-settings__tag-checkbox-all', $context).map(function () {
      new AllTag($(this), '.js-filter-settings__tag-checkbox', eventNameSpace)
    })

    $('.js-job-list', $context).map(function () {
      new JobList($(this), eventNameSpace)
    })

    $('.js-filter-settings__tag-checkbox', $context).map(function () {
      new CategoryTag($(this), eventNameSpace)
    })

    $('.js-filter-settings__tag-link', $context).on('click', event => {
      event.preventDefault()
      $(event.target).parent().siblings().click()
    })

    $('.js-filter-summary__total', $context).map(function () {
      new Headline($(this), eventNameSpace)
    })

    $('.js-filter-summary__save', $context).map(function () {
      new SaveSearch($(this))
    })

    $('.js-filter-search-term', $context).map(function () {
      new SearchTerms($(this), '.js-filter-search-term', eventNameSpace)
    })
  })
}
